import type { BeneficialOwnerResponse } from '@gcv/shared';
import { BeneficialOwnerUpdateAction } from '@gcv/shared';

export const getPossibleManagingBeneficialOwner = (
  beneficialOwners: BeneficialOwnerResponse[],
  templateResultId: string
): BeneficialOwnerResponse[] => {
  const activeOwners = beneficialOwners.filter((owner) => !owner.archived);
  const confirmedOwners = activeOwners.filter(
    (owner) => owner.template_result_map[templateResultId]?.confirmed_control_prong === true
  );

  if (confirmedOwners.length > 0) return confirmedOwners;

  return activeOwners.filter(
    (owner) =>
      owner.template_result_map[templateResultId]?.confirmed_control_prong === undefined &&
      owner.control_prong === true &&
      owner.last_update.update_action === BeneficialOwnerUpdateAction.Certify
  );
};
